import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module'; // Ensure this is imported
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ListScreenLayoutModule, LayoutModule, BaseService, httpInterceptorProviders, LibComponentsModule } from 'aplx-ng-lib-core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicModule } from '@ionic/angular';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { FCM } from '@ionic-native/fcm/ngx';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule, // This handles the lazy loading of aplx-ng-lib-* modules
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot({}),
    NgIdleKeepaliveModule.forRoot(),
    LibComponentsModule,
    LayoutModule,
    ListScreenLayoutModule
  ],
  providers: [FCM, httpInterceptorProviders, ConfirmationService, MessageService],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public translate: TranslateService, protected base: BaseService) {
    translate.setDefaultLang('en');
    translate.use('en');
    base.forRoot(environment);
  }
}